import React from "react";
import "../styles/travel-rewards.css";

import flightRoute from "../assets/images/flight-route.png";
import mangoBriefcase from "../assets/images/mango-briefcase.png";
import flightDelayed from "../assets/images/flight-delayed.png";
import delayedRoute from "../assets/images/delayed-route.png";

import mango from "../assets/icons/mango.svg";
import leaf from "../assets/icons/leaf.svg";

const TravelRewards = () => {
  return (
    <section className="travel-rewards-section">

      <div className="container">

        <div className="travel-card">

          {/* FLIGHT MINING */}

          <div className="flight-mining">

            <h2 className="section-heading">
              FLIGHT MINING
            </h2>

            <p className="section-text">
              Earn rewards based on your travel distance.
            </p>

            <div className="row align-items-center">

              {/* Stats */}

              <div className="col-lg-5">

                <div className="stats-grid">

                  <div className="stat-card">
                    <small>Total Flights</small>
                    <h4>128</h4>
                  </div>

                  <div className="stat-card">
                    <small>Total Distance</small>
                    <h4>
                      285,620 <span>km</span>
                    </h4>
                  </div>

                  <div className="stat-card">
                    <small>
                      Total Rewards
                      <img src={mango} alt="" />
                    </small>

                    <h4>
                      12,450 <span>mango</span>
                    </h4>
                  </div>

                  <div className="stat-card">
                    <small>
                      CO₂ Offset
                      <img src={leaf} alt="" />
                    </small>

                    <h4>
                      2,48 <span>ton</span>
                    </h4>
                  </div>

                </div>

              </div>

              {/* Route */}

              <div className="col-lg-4">

                <div className="route-area">

                  <img
                    src={flightRoute}
                    alt=""
                    className="img-fluid"
                  />

                </div>

              </div>

              {/* Mango */}

              <div className="col-lg-3 text-center">

                <img
                  src={mangoBriefcase}
                  alt=""
                  className="mango-character"
                />

              </div>

            </div>

          </div>

          {/* Divider */}

          <div className="section-divider"></div>

          {/* DELAY INSURANCE */}

          <div className="delay-insurance">

            <div className="row align-items-center">

              {/* Airport */}

              <div className="col-lg-5 text-center">

                <img
                  src={flightDelayed}
                  alt=""
                  className="img-fluid airport-image"
                />

              </div>

              {/* Content */}

              <div className="col-lg-7">

                <h2 className="section-heading">
                  DELAY INSURANCE
                </h2>

                <p className="section-text">
                  Get rewarded when your flight is delayed.
                </p>

                <div className="row g-3">

                  <div className="col-md-4">

                    <div className="reward-box">

                      <h6>
                        Flight Delayed
                      </h6>

                      <p>
                        Reward Processing
                      </p>

                      <div className="reward-value">
                        🍋 +80 MANGO
                      </div>

                    </div>

                  </div>

                  <div className="col-md-8">

                    <div className="route-delay-box text-center">

                      <img
                        src={delayedRoute}
                        alt=""
                        className="img-fluid w-75"
                      />

                    </div>

                  </div>

                </div>

                <div className="status-grid">

                  <div className="status-card">
                    <h6>Delay Detected</h6>
                    <p>Automatic Monitoring</p>
                  </div>

                  <div className="status-card">
                    <h6>API Verified</h6>
                    <p>Flight Data Verified</p>
                  </div>

                  <div className="status-card">
                    <h6>Auto Compensation</h6>
                    <p>Reward Sent</p>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default TravelRewards;